import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/Header/Header";
import InsuranceCard from "../../components/InsuranceCard/InsuranceCard";
import "./Dashboard.css";
import ProductGrid from "../../components/ProductGrid/ProductGrid";
import SubscriptionButton from "../../components/SubscriptionButton/SubscriptionButton";
import { useLoading } from "../../contexts/LoadingContext";
import {
  checkSubscription,
  userVerification,
} from "../../components/APICall/Api";
import LastFourServices from "../../components/ProductGridBelow/LastFourServices";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [msisdn, setSessionMsisdn] = useState(null);
  const { isLoading, setIsLoading } = useLoading();
  const params = new URLSearchParams(location.search);
  const msisdnnew = params.get("data");

  const queryString = window.location.search;
  const match = queryString.match(/signature=([^&]*)/);
  const signature = match ? match[1] : null;

  // const subscribedPackageDetails = useCallback(() => {
  //   navigate(`/subscribed-package-details`);
  // }, [navigate]);

  useEffect(() => {
    const verifyUser = async () => {
      setIsLoading(true);
      if (!msisdnnew || !signature) {
        setIsLoading(false);
        console.error("Missing required parameters");
        navigate("/error");
        return;
      }

      try {
        const result = await userVerification(signature, msisdnnew);
        if (result && result.statusCode === "0001") {
          const msisdnwithzero = "0" + msisdnnew;
          setSessionMsisdn(msisdnwithzero);
          sessionStorage.setItem("msisdn", JSON.stringify(msisdnwithzero));
          const session = JSON.parse(sessionStorage.getItem("msisdn"));
        } else {
          navigate("/error");
        }
      } catch (error) {
        console.error("Error during verification:", error);
        navigate("/error");
      } finally {
        setIsLoading(false);
      }
    };

    verifyUser();
  }, [navigate, signature, msisdnnew]);

  const handleCardClick = async (apiService, type) => {
    console.log("service name", apiService);
    console.log("service type", type);
    setIsLoading(true);
    try {
      const result = await checkSubscription(apiService, msisdn);

      if (result && result.statusCode === "0000") {
        console.log("User is subscribed");
        navigate(`/subscribed-package-details/${apiService}`, {
          state: { subscriptionData: result.payLoad },
        });
      } else if (result && result.statusCode === "0001") {
        console.log("User has no subscription");
        // Pass the payload as state to the InsuranceScreen
        navigate(`/insurancescreen/${type}/${apiService}`, {
          state: { payLoad: result.payLoad },
        });
      } else if (result && result.statusCode === "0002") {
        console.log("Validation error");
        // Optionally handle validation errors
      } else {
        console.log("Unexpected error or network issue");
      }
    } catch (error) {
      console.error("Error checking subscription:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="dashboard">
      <Header msisdn={msisdn} />
      <div className="container mt-1">
        {/* Upper Section with 3 Cards */}

        {/* code for the top 2 insurance */}
        <ProductGrid handleCardClick={handleCardClick} />

        <div className="custom-card mt-4 p-3">
          {/* code for all insurance */}
          {/* <div className="row">
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/livestock.png"
                label="Livestock Insurance"
                onClick={() => handleCardClick("API_LIS", "lifestock")}
              />
            </div>
            <div className="col-4 mb-1">
              <InsuranceCard icon="/images/health-insurance-new.png" label="Health Insurance" onClick={() => handleCardClick('API_HIS', 'healthlegal')}/>
            </div>
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/crops.png"
                label="Crop Insurance"
                onClick={() => handleCardClick()}
              />
            </div>
         
          </div> */}
          {/* code for the Bundle */}
          <div className="row">
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/health-insurance-new.png"
                label="Health Bundle"
                onClick={() => handleCardClick("API_HBS", "bundlelegalHealth")}
              />
            </div>
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/legal.png"
                label="Life Bundle"
                onClick={() => handleCardClick("API_LBS", "bundleLegallife")}
              />
            </div>

            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/accident.png"
                label="Agri Bundle"
                onClick={() =>
                  handleCardClick("API_ABS", "bundlelivestockAgri")
                }
              />
            </div>
          </div>

          {/* code for the Advisory */}
          {/* <div className="row">
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/veterinary.png"
                label="Veterinary Advisory"
                onClick={() => handleCardClick("API_VS", "veterinaryadvisory")}
              />
            </div>
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/agronomi.png"
                label="Agro Nomi Advisory"
                onClick={() => handleCardClick("API_AS", "agronomi")}
              />
            </div>

            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/health-advisory.png"
                label="Health Advisory"
                onClick={() => handleCardClick("API_THS", "healthadvisory")}
              />
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/lifelegal.png"
                label="Legal Advisory"
                onClick={() => handleCardClick("API_LS", "legaladvisory")}
              />
            </div>

          </div> */}

          {/* code for the Cards */}
          {/* <div className="row justify-content-center">
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/healthcard.png"
                label="Health Card"
                onClick={() => handleCardClick("API_HCB", "healthcard")}
              />
            </div>
            <div className="col-4 mb-1">
              <InsuranceCard
                icon="/images/healthcard-women.png"
                label="Health Card Women"
                onClick={() => handleCardClick("API_HCW", "healthcardwomen")}
              />
            </div>
          </div> */}
        </div>

        <div className="row">
          <div className="col-md-12 mt-4">
            <LastFourServices handleCardClick={handleCardClick} />
          </div>
        </div>
        <div className="text-center">
          <SubscriptionButton onClick={() => navigate("/all")} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
